import type { App } from "vue";
import {
  EmailDataSourceImpl,
  emailDataSourceKey,
} from "./data/datasources/email_datasource";

export function initEmailModule(app: App) {
  app.provide(emailDataSourceKey, new EmailDataSourceImpl());
}
